import { Theme, useMediaQuery } from "@mui/material";

export const isMobileView = () => useMediaQuery((theme: Theme) => theme.breakpoints.down("sm"));

export const bodyMassIndex = (weight: number, totalInches: number) => {
  return Number((weight * 703) / Math.pow(totalInches, 2));
};
